import {
	FeeTierDisplayUnit,
	StakedTier,
	StakedTierSelectValue,
	VolumeTier,
} from 'src/components/Modals/FeeTierModal/types';
import { BaseRadioItemProps } from 'src/components/primitives/RadioGroup/types';

export const FEE_TIER_DISPLAY_UNIT_OPTIONS: BaseRadioItemProps<FeeTierDisplayUnit>[] =
	[
		{ id: 'percentage', label: '%', value: 'percentage' },
		{ id: 'bps', label: 'bps', value: 'bps' },
	];

export const VOLUME_TIERS: VolumeTier[] = [
	// Display value for the first two are the same, but the first represents < $2M.
	{ title: '1', amount: 0, display: '$2M' },
	{ title: '2', amount: 2_000_000, display: '$2M' },
	{ title: '3', amount: 10_000_000, display: '$10M' },
	{ title: '4', amount: 20_000_000, display: '$20M' },
	{ title: '5', amount: 80_000_000, display: '$80M' },
	{ title: 'VIP', amount: 200_000_000, display: '$200M' },
];

export const STAKED_TIERS: StakedTier[] = [
	{ title: 'rookie', amount: 0, display: '0', discount: 0 },
	{ title: 'kickstarter', amount: 1_000, display: '1K', discount: 0.05 },
	{ title: 'racer', amount: 10_000, display: '10K', discount: 0.1 },
	{ title: 'elite', amount: 50_000, display: '50K', discount: 0.2 },
	{ title: 'master', amount: 100_000, display: '100K', discount: 0.3 },
	{ title: 'champion', amount: 250_000, display: '250K', discount: 0.4 },
];

export const STAKED_TIER_SELECT_OPTIONS: StakedTierSelectValue[] =
	STAKED_TIERS.map((tier) => ({
		...tier,
		selectId: tier.discount,
	}));
